<!-- Button Group -->
<div
	@fadeInOut
	*ngIf="buttonGroupConfig?.isRenderable"
	class="mx-auto w-100"
	[ngClass]="{
		'btn-group-vertical': alignVertical,
		'btn-group ': !alignVertical,
		'btn-group-unselected ': !hasSelectedButtonGroupItem,
		'btn-group-selected ': hasSelectedButtonGroupItem,
		'disabled': buttonGroupConfig?.isDisabled,
		'd-none': buttonGroupConfig?.isHidden
	}"
>

	<!-- Button Group Item -->
	<ng-container
		*ngFor="let buttonGroupItem of buttonGroupConfig?.items;
		let isFirst=first;
		let isLast=last;
		let itemIndex=index"
	>
		<label
			*ngIf="buttonGroupItem.isRenderable"
			class="d-flex flex-nowrap justify-content-center mb-0 btn button-group-item fw-medium fs-md"
			[ngClass]="{
				'active cursor-default': buttonGroupItem?.isSelected,
				'align-items-center': !buttonGroupItem.verticalAlignment || buttonGroupItem.verticalAlignment === verticalAlignmentEnum.CENTER,
				'align-items-end': buttonGroupItem.verticalAlignment === verticalAlignmentEnum.BOTTOM,
				'align-items-start': buttonGroupItem.verticalAlignment === verticalAlignmentEnum.TOP,
				'disabled': buttonGroupItem.isDisabled,
				'd-none': buttonGroupItem.isHidden
			}"
			[ngbTooltip]="buttonGroupItem.tooltip ? getI18nString( false, buttonGroupItem.tooltip ) : null"
			[triggers]="'hover'"
		>
			<input
				class="btn-check"
				type="radio"
				[checked]="buttonGroupItem?.isSelected"
				[value]="buttonGroupItem.id"
				(change)="onChange(buttonGroupItem)"
			>

			<!-- Prepended Label Content (projected) -->
			<span
				*ngIf="buttonGroupItem?.enforceLabelPrependedCustomTemplate"
				class="me-2"
			>
				<ng-template
					[ngTemplateOutlet]="buttonLabelPrependedTpl"
					[ngTemplateOutletContext]="{
						buttonGroupItem: buttonGroupItem,
						isFirst: isFirst,
						isLast: isLast,
						itemIndex: itemIndex
					}"
				></ng-template>
			</span>

			<!-- Main Label Content -->

			<!-- Default Label Template -->
			<ng-template
				#defaultButtonLabelTpl
				let-buttonGroupItem="buttonGroupItem"
				let-isFirst="isFirst"
				let-isLast="isLast"
				let-itemIndex="itemIndex"
			>
				<span>{{ buttonGroupItem.label }}</span>
			</ng-template>

			<!-- Projected Label Template -->
			<ng-template
				[ngTemplateOutlet]="buttonGroupItem?.enforceLabelCustomTemplate ? buttonLabelTpl : defaultButtonLabelTpl"
				[ngTemplateOutletContext]="{
					buttonGroupItem: buttonGroupItem,
					isFirst: isFirst,
					isLast: isLast,
					itemIndex: itemIndex
				}"
			></ng-template>

			<!-- Appended Label Content (projected) -->
			<span
				*ngIf="buttonGroupItem?.enforceLabelAppendedCustomTemplate"
				class="ms-2"
			>
				<ng-template
					[ngTemplateOutlet]="buttonLabelAppendedTpl"
					[ngTemplateOutletContext]="{
						buttonGroupItem: buttonGroupItem,
						isFirst: isFirst,
						isLast: isLast,
						itemIndex: itemIndex
					}"
				></ng-template>
			</span>
		</label>
	</ng-container>
</div>
